export default __webpack_public_path__ + "static/media/static_ip_banner.4795d615.svg";